module.exports = __webpack_public_path__ + "img/banner.bf24e247.png";